var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.6 149.3",
    style: {
      enableBackground: "new 0 0 236.6 149.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#016A4E;}\r\n\t.st1{fill:#009597;}\r\n\t.st2{fill:#ED1B2F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 92.7,
    className: "st0",
    width: 138.5,
    height: 12.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.3,25.3l9.3,23.4l16.5-8.7L148.8,8.3H128L98.8,62.8c0,0,14.4-0.4,23.6-7.4 C124.7,54.1,131.3,36.9,137.3,25.3L137.3,25.3L137.3,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.2,40l-16.5,8.7c-14.1,7.2-27.5,13.6-34.8,15.6c-19.1,5.5-42.3,8.8-50.6,1.4c-7.8-7,10.3-36.1,44.5-42.6 c5.6-1.2,8.8-0.9,8.8-0.9s-2.3-10-4.2-12.1c-2.6-3.1-5.1-3.8-8.8-3.3c-7.4,0.4-39,8.9-51.4,35.1c-6.9,14.9,2.3,30,8.3,34.4 c2.8,2,20.7,18.1,62.1,1.9C161.4,62.4,198,37.5,198,37.5V20.8C198,20.8,181.9,30,163.2,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.4,63.9c1.5,3.6,5.9,14,7,17c1.5,3.3,5.1,3.3,5.1,3.3h19l-14.2-29.4C164.3,57.7,158.5,60.8,152.4,63.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198,14.3c0,0-21.8,12.5-26.9,14.4c-4.7,1.9-6.4-0.6-7-1.5c-1.3-1.9-3.3-8.3-3.6-9.2c0.1,0,1.3,0.3,4.1-0.4 C167.9,16.8,198,0,198,0V14.3L198,14.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,144.2H6.3L4,148.8H0l9.8-19h4.1l9.8,19H19L16.8,144.2z M15.4,141.3l-3.7-7.5L8,141.3H15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,146.1l1.9-2.7c2.5,1.8,5.8,2.7,8.7,2.7c3,0,5.5-0.9,5.5-2.3c0-1.5-2.7-2-5.9-2.7c-4.3-0.9-9.5-2-9.5-5.8 c0-3.5,4.4-5.7,9.4-5.7c3.4,0,7,1,9.6,2.7l-1.9,2.7c-2.1-1.6-5-2.4-7.7-2.4s-5.3,0.8-5.3,2.2c0,1.3,2.5,1.8,5.5,2.4 c4.4,0.9,9.9,2,9.9,6.1c0,3.7-4.5,5.9-9.6,5.9C32.7,149.1,28.7,148,26,146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,146.1l1.9-2.7c2.5,1.8,5.8,2.7,8.7,2.7c3,0,5.5-0.9,5.5-2.3c0-1.5-2.7-2-5.9-2.7 c-4.3-0.9-9.5-2-9.5-5.8c0-3.5,4.4-5.7,9.4-5.7c3.4,0,7,1,9.6,2.7l-1.9,2.7c-2.1-1.6-5-2.4-7.7-2.4s-5.3,0.8-5.3,2.2 c0,1.3,2.5,1.8,5.5,2.4c4.4,0.9,9.9,2,9.9,6.1c0,3.7-4.5,5.9-9.6,5.9C55.6,149.1,51.6,148,48.8,146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.9,140.3v-10.4H77v10.6c0,3.4,2.4,5.7,5.9,5.7s5.9-2.3,5.9-5.7v-10.7h3.9v10.4c0,5.3-4,8.9-9.9,8.9 S72.9,145.6,72.9,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,129.8h10.3c4.8,0,8.6,1.9,8.6,6.1c0,3.3-2.4,5-5.6,5.7l6.2,7.2h-4.7l-5.6-6.6H102v6.6h-4.1V129.8 L97.9,129.8z M107.8,139.2c2.9,0,4.7-1.2,4.7-3.3c0-2-1.8-3.1-4.7-3.1h-5.9v6.4L107.8,139.2L107.8,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.7,144.2h-10.5l-2.3,4.6h-4.1l9.8-19h4.1l9.8,19H139L136.7,144.2z M135.2,141.3l-3.7-7.5l-3.7,7.5H135.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,135.3v13.5h-4.1v-19h4.1l11.6,13.5v-13.5h4.1v19H163L151.4,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.2,129.5c2.9,0,6,0.9,8.5,2.7l-1.9,2.5c-2-1.4-3.7-2.2-6.3-2.2c-4.5,0-8,2.8-8,6.9s3.5,6.9,8,6.9 c2.7,0,4.5-0.8,6.7-2.3l1.9,2.5c-2.5,1.8-5.7,2.8-8.8,2.8c-6.1,0-11.9-3.6-11.9-9.8C171.3,133.1,177.1,129.5,183.2,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.5,143.3v-13.5h17.2v3h-13.1v4.6h12v3h-12v2.9c0,1.7,0.8,2.4,2.4,2.4h11.1v3H201 C197.5,148.8,195.5,146.8,195.5,143.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.4,146.1l1.9-2.7c2.5,1.8,5.8,2.7,8.7,2.7c3,0,5.5-0.9,5.5-2.3c0-1.5-2.7-2-5.9-2.7 c-4.3-0.9-9.5-2-9.5-5.8c0-3.5,4.4-5.7,9.4-5.7c3.4,0,7,1,9.6,2.7l-1.9,2.7c-2.1-1.6-5-2.4-7.7-2.4s-5.3,0.8-5.3,2.2 c0,1.3,2.5,1.8,5.5,2.4c4.4,0.9,9.9,2,9.9,6.1c0,3.7-4.5,5.9-9.6,5.9C223.1,149.1,219.1,148,216.4,146.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaaLogo);
export default __webpack_public_path__ + "static/media/caa-logo.3b8d3751f3c17eb6628dab742d5707e2.svg";
export { ForwardRef as ReactComponent };